// Import Redux toolkit
import { createSlice } from "@reduxjs/toolkit";

// Import Redux actions
import { fetchUser, login } from "../actions/AuthAction";
import authConfig from "src/configs/auth";

const AuthSlice = createSlice({
  name: "Auth",
  initialState: {
    user: null,
    loading: false,
    error: null,
    isInitialized: false,
    loadingBtnLoader: false,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.error = null;
      window.localStorage.removeItem(authConfig.storageTokenKeyName);
      window.localStorage.removeItem(authConfig.storageRefreshTokenKeyName);
      window.localStorage.removeItem(authConfig.storageUserDataKeyName);
    },
  },
  extraReducers: (builder) => {
    builder
      // Login Cases
      .addCase(login.pending, (state) => {
        state.error = null;
        state.loadingBtnLoader = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.loadingBtnLoader = false;
      })
      .addCase(login.rejected, (state, action) => {
        state.error = action.payload;
        state.loadingBtnLoader = false;
      })

      // Fetch User Cases
      .addCase(fetchUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.isInitialized = true;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isInitialized = false;
      });
  },
});

export const { logout } = AuthSlice.actions;
export default AuthSlice.reducer;
